var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "48076DBA-B6A5-44B4-B580-7BC4E46AF625") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manager-|-My-Account",
    transform: "translate(-813.000000, -302.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(333.000000, 124.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-3",
    transform: "translate(480.000000, 178.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.8,0 C5.5,0 5.4,0.2 5.5,0.5 L7,4.2 L3.1,4.2 C1.4,4.2 0,5.6 0,7.3 L0,17 C0,18.7 1.4,20.1 3.1,20.1 L17.4,20.1 C19.1,20.1 20.5,18.7 20.5,17 L20.5,7.3 C20.5,5.6 19.1,4.2 17.4,4.2 L13.7,4.2 L15.2,0.5 C15.3,0.3 15.1,0 14.9,0 L12.1,0 C12,0 11.8,0.1 11.8,0.2 L10.4,3.7 L9,0.2 C8.9,0.1 8.8,0 8.7,0 L5.8,0 Z M6.3,0.8 L8.3,0.8 L8.4,1 C8.5,1.3 10.5,6.2 10.6,6.6 L10.8,7.1 L8.8,7.1 L8.7,6.9 C8.6,6.7 6.6,1.7 6.5,1.3 L6.3,0.8 Z M12.3,0.8 L14.3,0.8 L12.9,4.2 L10.9,4.2 L12.2,1 L12.3,0.8 Z M3,4.9 L7.2,4.9 L8,7 L7.1,7 C6.9,7 6.7,7.2 6.7,7.4 C6.7,7.6 6.9,7.8 7.1,7.8 L12.7,7.8 C12.9,7.8 13.1,7.6 13.1,7.4 C13.1,7.2 12.9,7 12.7,7 L11.6,7 L10.8,4.9 L17.4,4.9 C18.7,4.9 19.8,6 19.8,7.3 L19.8,16.7 L19.8,16.7 L19.8,17 C19.8,18.3 18.7,19.4 17.4,19.4 L3.1,19.4 C1.8,19.4 0.7,18.3 0.7,17 L0.7,7.3 C0.6,6 1.7,4.9 3,4.9 L3,4.9 Z M10.2,9.8 C9.1,9.8 8.2,10.7 8.2,11.8 C8.2,12.3 8.4,12.7 8.6,13 L8.8,13.3 L8.5,13.5 C7.5,14.1 6.8,15.2 6.8,16.4 L6.8,17.1 C6.8,17.3 7,17.5 7.2,17.5 L13.2,17.5 C13.4,17.5 13.6,17.3 13.6,17.1 L13.6,16.4 C13.6,15.1 12.9,14.1 11.9,13.5 L11.6,13.3 L11.8,13 C12.1,12.7 12.2,12.2 12.2,11.8 C12.2,10.6 11.3,9.8 10.2,9.8 L10.2,9.8 Z M10.2,10.5 C10.9,10.5 11.5,11.1 11.5,11.8 C11.5,12.5 10.9,13.1 10.2,13.1 C9.5,13.1 8.9,12.5 8.9,11.8 C8.9,11 9.5,10.5 10.2,10.5 Z M10.2,13.7 C11.7,13.7 12.8,14.9 12.8,16.3 L12.8,16.6 L7.5,16.6 L7.5,16.3 C7.6,14.9 8.7,13.7 10.2,13.7 L10.2,13.7 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.49264964ec1fe3526eb690e3237c19e6.svg";
export { ForwardRef as ReactComponent };